import axiosInstance from '../Config/AxiosInstance';

const PREFIX = `/clinic/clinicAdmin`;

export const disableOrEnableUser = (id, data) => {
  return axiosInstance.post(PREFIX + `/toggle-ability/${id}`, data);
};

// Fetches the clinic-level config (e.g. whether Patient Type (STC/LTC) is required).
export const getClinicSettings = () => {
  return axiosInstance.get(PREFIX + `/config`);
};

// Persists clinic-level config. `data` shape: { patientTermTypeRequired: boolean }
export const updateClinicSettings = data => {
  return axiosInstance.post(PREFIX + `/config`, data);
};
